<template>
  <div>
     <el-form ref="searchForm" :model="searchData" inline>
      <el-form-item label="UID">
        <el-input v-model.number="searchData.user_id" size="mini" />
      </el-form-item>
      <el-form-item>
        <el-button size="mini" @click="handlerSearch">
            查找
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="data"
      @sort-change="handlerSort"
      :default-sort = "{prop: 'user_id', order: 'descending'}"
    >
      <el-table-column
        prop="user_id"
        label="UId"
        sortable="custom"
      />
      <el-table-column
        label="头像"
      >
        <template slot-scope="{row}">
            <el-image style="width: 50px;" :src="row.avatar"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="nickname"
        label="昵称"
      />
      <el-table-column
        prop="balance"
        label="可提现金额"
        :formatter="function(v) { return v['balance'] / 100 + '元' }"
      />
      <el-table-column
        prop="freeze"
        label="冻结金额"
        :formatter="function(v) { return v['freeze'] / 100 + '元' }"
      />
      <el-table-column
        prop="withdraw"
        label="已提现金额"
        :formatter="function(v) { return v['withdraw'] / 100 + '元' }"
      />
    </el-table>
    <pager
      api="business_list"
      :filter="filter"
      :sort="sort"
      model="wallet"
      @data-changed="onDataChanged"
    />
  </div>
</template>
<script>
  import Pager from "../ui/Pager"

  export default {
    name: 'WalletList',
    components: { Pager },
    data () {
      return {
        searchData: {},
        data: [],
        filter: {},
        sort: [
          {
            field: 'user_id',
            reverse: true
          }
        ]
      }
    },
    computed: {
    
    },
    methods: {
      onDataChanged: function (data) {
        this.data = data
      },

      handlerSearch() {
        let filter = {}
        if (this.searchData.user_id) {
          filter.user_id = this.searchData.user_id
        }
        this.filter = filter
      },
      handlerSort(column) {
        this.sort = [
          {
            field: column.prop,
            reverse: column.order === 'descending'
          }
        ]
      }
    }
  }
</script>